export default {
    LOGIN: '/v1/auth',
    LOGIN_CAS: '/v1/auth/cas',
    EMAIL: '/v1/auth/send-email',
    FORGOT_PASSWORD: '/v1/auth/validate-email-password',
    TOKEN:'/v1/auth/token-password-validation',
    DELETE_TOKEN:'v1/auth/disconect-logged-user',
    VALIDAR_TOKEN: 'v1/auth/token-password-validation',
    CHANGE_USER_DATA: 'v1/auth/change-user-data',

    // LISTAS
    CENTROS_DE_CUSTO: 'v1/centroDeCusto/listar',
    EMPRESAS: 'v1/empresa/listar',
    GRUPOS: 'v1/cliente/listar',
    CLUSTERS: '/v1/cluster/listar-options',
    LINHAS_DRE: 'v1/DRE/listar-linhas-da-dre',
    EMPRESAS_DASH: 'v1/Empresa/obter-para-dashboard',

    //DRE
    DRE: '/v1/dre/',
    DRE_MODELOS: '/v1/dre/listar-modelos',
    DRE_LISTA: '/v1/dre/listar-dre',
    DRE_EXPORTAR: '/v1/dre/exportar',
    DRE_EXPORTAR_SISTEMA: 'v1/dre/exportar-para-sistema',
    DRE_EXPORTAR_SISTEMA_TODAS_LINHAS: 'v1/dre/exportar-em-excel-com-todas-linhas',
    DRE_EXPORTAR_DOWNLOAD: '/v1/dre/exportar-download',
    DRE_EXPORTAR_PLANILHA_MODELO_VALORES_MANUAIS: '/v1/dre/exportar-planilha-modelo-valores-manuais',
    DRE_LINHAS_VALORES_MANUAIS: '/v1/dre/linhas-valores-manuais',
    DRE_LISTA_VALORES_MANUAIS: '/v1/dre/lista-valores-manuais',
    DRE_ATUALIZAR_VALORES_MANUAIS: '/v1/dre/atualizar-valores-manuais',
    DRE_LISTA_CLUSTER: 'v1/cluster/listar-options',
    DRE_EXPORTAR_EM_MASSA: 'v1/dre/exportar-em-massa',
    DRE_DETALHES_LINHA_DRE: "v1/dre/detalhes-linha-dre",
    DRE_EXPORTAR_DETALHES_LINHA: "v1/dre/exportar-detalhes-linha",
    DRE_EXPORTAR_POR_CCS: '/v1/dre/exportar-por-ccs',
    DRE_EXPORTAR_DETALHES_MULTIPLOS: '/v1/dre/exportar-detalhes-multiplos',
    DRE_TODAS_LINHAS: '/v1/dre/todas-linhas',
    DRE_EXPORTAR_SISTEMA_TODAS_LINHAS_E_DETALHES: 'v1/dre/exportar-em-excel-com-todas-linhas-detalhes',
    //CLUSTER
    CLUSTER_LISTAR: '/v1/cluster/listar',
    CLUSTER_LISTAR_GRID: '/v1/cluster/pegar-para-grid',
    CLUSTER_SALVAR: '/v1/cluster/save',
    CLUSTER_EDITAR: '/v1/cluster/edit',
    CLUSTER_GETONE: '/v1/cluster/getOne',
    CLUSTER_DELETAR: '/v1/cluster/deletar',
    CLUSTER_POR_EMPRESA: '/v1/Cluster/listar-de-acordo-empresas',
    CLUSTER_POR_CENTRO_CUSTO: '/v1/Cluster/listar-de-acordo-ccs',
    CLUSTER_DOWNLOAD_MODELO: '/v1/Cluster/download-modelo-importacao',
    CLUSTER_GERAR_RELATORIO: '/v1/cluster/gerar-relatorio-clusters',

    //FILTRO EMPRESAS
    CLUSTER_OBTER_EMPRESAS: '/v1/empresa/obter-empresas-cluster',
    CLUSTER_MARCAS: '/v1/marcas/listar',
    CLUSTER_TIPO_ESTABELECIMENTO: '/v1/tipodeestabelecimento/listar',
    CLUSTER_LOCAL_ESTABELECIMENTO: '/v1/localestabelecimento/listar',

    //LOCALIDADE
    CLUSTER_REGIOES: 'https://servicodados.ibge.gov.br/api/v1/localidades/regioes',
    CLUSTER_ESTADOS: 'https://servicodados.ibge.gov.br/api/v1/localidades/estados',
    CLUSTER_CIDADES: 'https://servicodados.ibge.gov.br/api/v1/localidades/municipios',

    //FLUXO DE CAIXA
    FLUXO_CAIXA_ANALITICO: 'v1/fluxodecaixa/get-valores-analiticos',
    FLUXO_CAIXA_ANALITICO_MODELOS: '/v1/fluxodecaixa/listar-modelos-analiticos',
    FLUXO_CAIXA_ANALITICO_EXPORTAR: 'v1/fluxodecaixa/download-valores-analiticos',
    FLUXO_CAIXA_EXPORTAR_EM_MASSA: 'v1/fluxodecaixa/exportar-em-massa',
    FLUXO_CAIXA_OBTER_DETALHE: 'v1/fluxodecaixa/obter-detalhes-da-linha',
    FLUXO_CAIXA_EXPORTAR_DETALHE: 'v1/fluxodecaixa/exportar-detalhes-fluxo',
    FLUXO_CAIXA_EXPORTAR_TABELA: 'v1/fluxodecaixa/exportar-dfc-formato-tabela',
    FLUXO_CAIXA_EXPORTAR_TABELA_TODAS_LINHAS: 'v1/fluxodecaixa/exportar-dfc-formato-tabela-todas-linhas',

    //EXTRATO BANCÁRIO
    LISTAR_EXTRATO: 'v1/ExtratoBancario/listar',
    EXPORTAR_EXTRATO: 'v1/ExtratoBancario/exportar',
    CONTAS: 'v1/ContaBancaria/listar',
    EMPRESAS_POR_CLIENTE: 'v1/Empresa/listar-empresas-grupo',


    //de-para antigo
    DE_PARA_LISTAR_TODOS: "/v1/DePara/listar-todos",

    //De-Para
    DE_PARA_LISTAR: "/v1/DePara/listar",
    DE_PARA_LISTAR_FRANQUEADO: "/v1/DePara/listar-franqueado",
    DE_PARA_APROVAR_JUSTIFICATIVAS: "/v1/DePara/aprovar-configuracoes",
    DE_PARA_DESAPROVAR_JUSTIFICATIVAS: "/v1/DePara/desaprovar-configuracoes",
    DE_PARA_PENDENTE: "/v1/DePara/listar-por-franqueado-marca-pendente",
    DE_PARA_REVISAO: "/v1/DePara/listar-por-franqueado-marca-revisao",
    DE_PARA_APROVADO: "/v1/DePara/listar-por-franqueado-marca-aprovado",
    DE_PARA_APROVAR: "/v1/DePara/aprovar-configuracoes",
    DE_PARA_DESAPROVAR: "/v1/DePara/desaprovar-configuracoes",
    DE_PARA_GERACAO_RELATORIO: "/v1/DePara/solicitar-geracao-relatorio",
    DE_PARA_DESFAZER: "/v1/DePara/desfazer-depara",
    DE_PARA_VINCULAR_AUTOMATICAMENTE: "/v1/DePara/vincular-automaticamente",
    
    //SOLICITACOES
    SOLICITACOES_LISTAR: "/v1/SolicitacoesDoFranqueado/listar-paginado",
    SOLICITACOES_GETONE: "/v1/SolicitacoesDoFranqueado/getOne",
    SOLICITACOES_REJEITAR: "/v1/SolicitacoesDoFranqueado/rejeitar-solicitacoes",
    SOLICITACOES_APROVAR: "/v1/SolicitacoesDoFranqueado/aprovar-solicitacoes",

    //PLANO DE CONTAS
    PLANO_DE_CONTAS_APAGAR: "/v1/PlanoDeContas/a-pagar",
    PLANO_DE_CONTAS_ARECEBER: "/v1/PlanoDeContas/a-receber",
    PLANO_DE_CONTAS_TODOS: "/v1/PlanoDeContas/todos",

    //CLIENTE SETUP
    CLIENTE_SETUP_GET: "/v1/Cliente/cliente-setup-get",
    CLIENTE_SETUP_SAVE: "/v1/Cliente/cliente-setup-save",
    CLIENTE_SOLICITAR_PREMIUM: "/v1/Cliente/solicitar-premium",

    //ESTOQUE
    ESTOQUE_EXPORTAR_CMV: "/v1/Estoque/exportar-cmv",
    ESTOQUE_EXPORTAR_POSICAO_ESTOQUE: "/v1/Estoque/exportar-posicao-estoque",
    ESTOQUE_EXPORTAR_ENTRADA_ESTOQUE: "/v1/Estoque/exportar-entrada-estoque",
    ESTOQUE_EXPORTAR_CATALOGO_PRECOS: "/v1/Estoque/exportar-catalogo-precos",

    //Upload
    UPLOAD_FILE: "/v1/arquivo/upload",
    UPLOAD_FILE_LIST: "v1/arquivo",
    EXPORT_FILE_LIST_ERROR:"/v1/arquivo/exportar-notas-status",
    ARQUIVO_DOWNLOAD:"/v1/arquivo/exportar-arquivo",

    //Relatorio
    RELATORIO_LIST: "v1/relatorio",
    RELATORIO_DOWNLOAD: "v1/relatorio/download-em-massa",
    RELATORIO_TIPO_ORIGEM: "v1/Relatorio/obter-tipos-relatorio",

    //Sincronizacao
    CRIAR_SINCRONIZACAO: 'v1/sincronizacao/criar-sincronizacao',
    LISTAR_SINCRONIZACAO_FINALIZADOS: 'v1/sincronizacao/listar-finalizados',
    LISTAR_SINCRONIZACAO_PROCESSANDO: 'v1/sincronizacao/listar-processando-aguardando',
    OBTER_ATUALIZADOS: 'v1/sincronizacao/obter-atualizado',

    //ConfigSincronizacao
    CRIAR_CONFIG_SINCRONIZACAO: 'v1/sincronizacao/criar-config-sincronizacao',
    OBTER_CONFIG_SINCRONIZACAO: 'v1/sincronizacao/obter-config-sincronizacao',
    EDITAR_CONFIG_SINCRONIZACAO: 'v1/sincronizacao/editar-config-sincronizacao',

    //Dashboard
    // KPI - Cards
    KPIS: 'v1/Kpi',  // GET E POST
    PEGAR_DASHBOARD: 'v1/Kpi/pegar-dashboard',
    EXPORTAR_GRAFICO: 'v1/kpi/exportar-grafico',

    //GRÁFICOS
    CHARTS: 'v1/Kpi/pegar-dados-para-grafico',
    //Logo
    LOGO: '/v1/logo',

    //Empresas
    LISTAR_EMPRESAS: 'v1/empresa/listar-empresas',
    EXPORTAR_EMPRESAS: 'v1/empresa/exportar-empresas',
    EDITAR_EMPRESA: 'v1/empresa/editar-apelido-m2',

    //Centros de Custos
    LISTAR_CENTROS_CUSTOS: 'v1/centroDeCusto/listar-centros-custos',
    EXPORTAR_CENTROS_CUSTOS: 'v1/centroDeCusto/exportar-centros-custos',
    EDITAR_CENTROS_CUSTOS_APELIDO: 'v1/centroDeCusto/editar-apelido',

    // Webservice
    SOLICITAR_WEBSERVICE: 'v1/WebServiceFinancas/solicitar-webservice',
    LISTAR_CALLS: 'v1/WebServiceFinancas/listar-calls',
    DETALHES_CALL: 'v1/WebServiceFinancas/obter-call',
    OBTER_TIPOS_WEBSERVICE: 'v1/WebServiceFinancas/obter-tipos-webservice',

    // Chaves Api
    CRIAR_CHAVE_API: 'V1/WebServiceAPI/save',
    EDITAR_CHAVE_API: 'V1/WebServiceAPI/edit',
    DELETAR_CHAVE_API: 'V1/WebServiceAPI/delete',
    GET_CHAVE_API: 'V1/WebServiceAPI/getOne',
    LISTA_CHAVE_API: 'V1/WebServiceAPI/getAll',
    
    // Usuarios
    OBTER_USERS: "v1/User/pegar-para-grid",
    CRIAR_USER: "/v1/User/criar-user",
    GETONE_USER: '/v1/User/getOne',
    DELETAR_USER: "/v1/User/deletar",
    EDITAR_USER: "/v1/User/editar-user",
    RESET_USER_PASSWORD: "/v1/User/reset-password",
    ATIVAR_DESATIVAR: "/v1/User/ativar-ou-desativar",
    USUARIOS_DOWNLOAD_MODELO: '/v1/user/download-modelo-importacao',

    // Regra de acessos
    LISTAR_REGRAS_DE_ACESSOS: 'v1/RegraDeAcessos/obter-regras-do-franqueador',
    OBTER_REGRA_POR_ID: 'v1/RegraDeAcessos/pegar-por-id',
    OBTER_REGRAS_DE_ACESSO_OPTIONS: 'v1/RegraDeAcessos/obter-options',
    OBTER_REGRAS_DO_SISTEMA: 'v1/RegraDeAcessos/obter-regras-do-sistema',
    CRIAR_UMA_REGRA: '/v1/RegraDeAcessos/criar-regra',
    EXCLUIR_UMA_REGRA: '/v1/RegraDeAcessos/excluir-regra',
    EDITAR_UMA_REGRA: '/v1/RegraDeAcessos/editar-regra',

    // Comparativo - Mapeamento retroativo
    SOLICITAR_COMPARATIVO: '/v1/Comparativo/solicitar-comparativo',
    GET_GRID_COMPARATIVO: '/v1/Comparativo/obter-grid',
    GET_COMPARATIVO_POR_ID: '/v1/Comparativo/obter-por-id',
    EXPORTAR_COMPARATIVO: '/v1/Comparativo/exportar-comparativo',

    //Plano de Contas
    LISTAR_PLANO_DE_CONTAS: '/v1/PlanoDeContas/todos',
    LISTAR_PLANO_DE_CONTAS_RECEBER: '/v1/PlanoDeContas/a-receber',
    LISTAR_PLANO_DE_CONTAS_PAGAR: '/v1/PlanoDeContas/a-pagar',
    LISTAR_PLANO_DE_CONTAS_PARA_VINCULO: 'v1/DePara/listar-planos-do-franqueado-para-vinculo',
    CRIAR_FRANQUEADO_DEPARA: '/v1/DePara/criar-franqueado-depara',
    CRIAR_FRANQUEADOR_DEPARA: '/v1/DePara/criar-franqueador-depara',

    // nps
    SALVAR_USUARIO_NPS: '/v1/User/criar-nps',
    OBTER_USUARIO_NPS: '/v1/User/pegar-nps',

    //Indice de gestão
    IG_OBTER_DETALHES: '/v1/IndiceDeGestao/obter-detalhes',
    IG_OBTER_TOTAL: '/v1/IndiceDeGestao/obter-todos-cards',
    IG_GERAR_RELATORIO: '/v1/IndiceDeGestao/gerar-relatorio-igdetalhes',

    // Contasbancarias
    OBTER_CONTAS_VINCULADAS: '/v1/contabancaria/obter-contas-vinculadas',
    EXPORTAR_CONTAS_VINCULADAS: '/v1/contaBancaria/exportar-contas-vinculadas',
}
